import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './Checkbox.module.scss';

const Checkbox = props => (
  <label className={classNames(props.className, styles.container, {
    [styles.small]: props.size === 'small',    
  })}>
    <span>{props.label && props.label}</span>
    <input type='checkbox' {...props} />
    <span className={styles.checkmark} />
  </label>
);

Checkbox.propTypes = {
  /** Handle checked boolean */
  checked: PropTypes.bool,
  /** Classname */
  className: PropTypes.string,
  /** Text label next to checkbox */
  label: PropTypes.string,
  /** Name to reference checkbox input */
  name: PropTypes.name,
  /** On Change funciton. Can pass input name to update checkboxes dynamically outside of component */
  onChange: PropTypes.func
};

Checkbox.defaultProps = {
  size: 'default'
};

export default Checkbox;
